import { useCallback, useContext } from 'react'
import Chip from '@mui/material/Chip'
import SvgIcon from '@mui/material/SvgIcon'
import { TreeItem, TreeView } from '@mui/x-tree-view'
import { array, arrayOf, oneOf, func, string } from 'prop-types'
import { folderContext } from '@contexts'
import { Recurser } from './recurser'

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  )
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  )
}

function CloseSquare(props) {
  return (
    <SvgIcon className="close" fontSize="inherit" {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  )
}

export const CvsTreeSelect = ({
  root = [],
  fetchChildren = () => {},
  onSelected = () => {},
  selected = '',
}) => {
  const { boxFolders } = useContext(folderContext)

  const Component = useCallback(
    ({ id, children, name }) => {
      return !id ? null : (
        <TreeItem
          onClick={() => onSelected(id)}
          selected={selected === id}
          nodeId={id}
          label={name}
        >
          {children}
        </TreeItem>
      )
    },
    [selected, onSelected],
  )

  const recursiveNames = useCallback(
    id =>
      typeof boxFolders[id] !== 'undefined'
        ? `${recursiveNames(boxFolders[id].parent)}/ ${boxFolders[id].name}`
        : '',
    [boxFolders],
  )

  return (
    <div>
      <Chip label={recursiveNames(selected) || '/'} />
      <TreeView
        defaultExpanded={[0]}
        defaultCollapseIcon={<MinusSquare />}
        defaultExpandIcon={<PlusSquare />}
        defaultEndIcon={<CloseSquare />}
      >
        <TreeItem selected={selected === 0} nodeId={0} label="/" onClick={() => onSelected(0)}>
          {root.map(({ id, ...rest }) => (
            <Recurser key={id} Component={Component} id={id} getItems={fetchChildren} {...rest} />
          ))}
        </TreeItem>
      </TreeView>
    </div>
  )
}

CvsTreeSelect.propTypes = {
  root: array,
  selected: string,
  onSelected: func,
  fetchChildren: func,
  selectable: arrayOf(oneOf(['node', 'dir'])),
  defaultExpanded: array,
}
